var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCandado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7782ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3d47c1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_125",
    "data-name": "Grupo 125",
    transform: "translate(-126 -816)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_76",
    "data-name": "Rect\\xE1ngulo 76",
    width: 23,
    height: 23,
    rx: 3,
    transform: "translate(126 816)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-lock",
    "data-name": "Icon awesome-lock",
    d: "M9.475,5.306H8.906V3.6a3.6,3.6,0,0,0-7.2,0V5.306H1.137A1.137,1.137,0,0,0,0,6.443v4.548a1.137,1.137,0,0,0,1.137,1.137H9.475a1.137,1.137,0,0,0,1.137-1.137V6.443A1.137,1.137,0,0,0,9.475,5.306Zm-2.463,0H3.6V3.6a1.705,1.705,0,0,1,3.411,0Z",
    transform: "translate(132.194 820.436)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandado);
export default __webpack_public_path__ + "static/media/candado.7df524490538e8770f1a984a0652a529.svg";
export { ForwardRef as ReactComponent };